/**
 * Revise Text Service - Revise the text or message by improving the grammar or
 * any fixing the spelling mistakes.
 */

import { Injectable } from '@angular/core';
import { FreelancerHttp } from '@freelancer/freelancer-http';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { firstValueFrom } from 'rxjs';

@UntilDestroy({ className: 'ReviseTextService' })
@Injectable({
  providedIn: 'root',
})
export class ReviseTextService {
  constructor(private freelancerHttp: FreelancerHttp) {}

  async reviseText(textToRevise: string, projectId?: number): Promise<string> {
    return firstValueFrom(
      this.freelancerHttp
        .post(
          'text-service/reviseText.php',
          { textToRevise, projectId },
          { isGaf: true },
        )
        .pipe(untilDestroyed(this)),
    ).then(response => {
      if (response.status === 'success') {
        return response.result.revisedText;
      }

      throw new Error(`Unsuccessful reviseText request: ${response.errorCode}`);
    });
  }
}
